module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.a9fdc08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/fullscreen-image_hero.png
// module id = zWmo
// module chunks = 0